import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FOOTER_LINKS } from "../../utils/data/footer";
import { Urls } from "../../utils/urls";
import { ApiService } from "../../shared/services/api.service";
import { CommonDataService } from "../../shared/services/common-data.service";
import { WriteUsComponent } from "../../components/pop-ups/write-us/write-us.component";
import { CallBackComponent } from "../../components/pop-ups/call-back/call-back.component";
import { LocateUsComponent } from "../../components/pop-ups/locate-us/locate-us.component";
import { Thank_You, Something_went_wrong } from '@root/app.constant';
import { environment } from '../../../environments/environment.prod';
import { RedirectionService } from "@root/shared/services/redirection.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  date = new Date();
  showPopUp = false;
  mobNumberPattern = "^((\\+91-?)|0)?[6-9][0-9]{9}$";
  alphaPattern = "^[a-zA-Z ]*$";
  userData = {
    name: "",
    phoneNum: "+91-",
  };
  footerLinks: any;
  activeId = 0;
  flag: boolean = false;

  constructor(
    private router: Router,
    public apiService: ApiService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    public commonDataService: CommonDataService,
    private redirectionService : RedirectionService
  ) { }

  ngOnInit() {
    this.setFlag();
    this.footerLinks = FOOTER_LINKS[0];
  }

  gotoTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  setPopUp = (val: boolean) => {
    this.showPopUp = val;
    if (val) {
      this.scrollSection();
    }
  };

  scrollSection = () => {
    const el: HTMLElement | null = document.getElementById("pop-up-content");
    if (el) {
      setTimeout(() => el.scrollIntoView(), 0);
    }
  };

  navFooterLink = (link: any) => {
    this.router.navigate([link]);
  };

  submitContactDetails = (formVal: any) => {
    this.apiService
      .postData(
        Urls.postContactDetails,
        this.commonDataService.convertToString(this.userData)
      )
      .subscribe((response: any) => {
        if (response.status === 0) {
          this.toastr.success(Thank_You);
          formVal.resetForm();
          this.userData = {
            name: "",
            phoneNum: "+91-",
          };
        } else {
          this.toastr.error(Something_went_wrong);
        }
      });
  };

  viewWebsite = (url: string) => {
    if (url === "careers") {
      this.navFooterLink(url);
    } else {
      window.open(url, "_blank");
    }
  };

  openHelpers = (val: any) => {
    const width = window.innerWidth;
    if (width <= 768) {
      this.navFooterLink(val);
    } else {
      if (val === "call-back") {
        this.modalService.open(CallBackComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else if (val === "write-to-us") {
        this.modalService.open(WriteUsComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else if (val === "locate-us") {
        this.modalService.open(LocateUsComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else {
        this.navFooterLink(val);
      }
    }
  };

  setActive = (val: number) => {
    if (this.activeId === -1) {
      this.activeId = val;
    } else {
      this.activeId = -1;
    }
  };

  setFlag() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();

    if (year == 2023 && month == 9) {
      if (day >= 6 && day <= 15) {
        this.flag = true;
      }
      else {
        this.flag = false;
      }
    }
  }

  accountStatements = () => {
    window.open("https://mfs.kfintech.com/investor/General/StatementsAndReports", "_blank");
  };

  digitalKyc = () => {
    this.redirectionService.redirectToInvestorPortal("login/kyc");
    // if (!environment.isDRBuild) {
    //   if (environment.baseurl === 'https://dev.itiamc.com:8485/jeeth/api/v1/catalog/') {
    //     window.open("https://dev.itiamc.com:8486/#/login/kyc", "_blank"); // UAT-inv
    //   }
    //   else if (environment.baseurl === "https://itiamc.com/jeeth/api/v1/catalog/") {
    //     window.open("https://investonline.itiamc.com/#/login/kyc", "_blank"); // Prod-inv
    //   }
    //   else {
    //     window.open("https://investonline.itiamc.com/#/login/kyc", "_blank"); // Prod-inv
    //   }
    // }
    // else {
    //   window.open("https://investonline.itiamc.com/#/login/kyc", "_blank"); //DR-inv
    // }
  };
  ARNHardcodedLink(){
    window.open("https://welcome.itiamc.com/Promotions", "_blank");
  }

  externalLink(type) {
    if (type === 'ARN') {
      window.open("https://welcome.itiamc.com/Promotions", "_blank");
    }
    else if (type === 'MITRA') {
      window.open("https://app.mfcentral.com/links/inactive-folios", "_blank");
    } else if (type === 'KYC') {
      window.open("https://mfs.kfintech.com/Investor/General/ValidateKYC", "_blank");
    } else if (type === 'DISTRIBUTOR_EMPANELMENT_DISCLOSURE') {
      window.open("https://mfs.kfintech.com/investor/General/distributerCorner?AMCCODE=CCAB2FC7-F0C5-4E58-ACC6-860704A9902F", "_blank");
    }
  }


}
